import { useEffect } from "react";
import type { Anchor } from "@nabla/api";
import type { Point } from "../../client/index.ts";
import { offeredAnchor } from "../navigation/Link.tsx";


export interface Asking {
  readonly anchor: Anchor;
  readonly name: string;
  readonly gerenciador?: string;
  readonly at?: Point;
}

function askingAt(target: EventTarget | null, at: Point): Asking | undefined {
  const element = target instanceof Element ? target.closest("[data-ask]") : null;
  if (!(element instanceof HTMLElement)) return undefined;
  const anchor = offeredAnchor(element.dataset["ask"] ?? "");
  if (anchor === undefined) return undefined;
  const gerenciador = element.dataset["askGerenciador"];
  return { anchor, name: element.dataset["askNome"] ?? "", ...(gerenciador ? { gerenciador } : {}), at };
}

export function useAskGestures(open: ((asking: Asking) => void) | undefined): void {
  useEffect(() => {
    if (open === undefined) return;
    let timer: ReturnType<typeof setTimeout> | undefined;
    let start: { x: number; y: number } | undefined;
    const context = (event: MouseEvent) => {
      const asking = askingAt(event.target, { x: event.clientX, y: event.clientY });
      if (!asking) return;
      event.preventDefault();
      open(asking);
    };
    const down = (event: PointerEvent) => {
      if (event.pointerType !== "touch") return;
      cancel();
      if (!event.isPrimary) return;
      start = { x: event.clientX, y: event.clientY };
      const target = event.target;
      timer = setTimeout(() => {
        const asking = askingAt(target, start ?? { x: 0, y: 0 });
        if (asking) open(asking);
      }, 520);
    };
    const cancel = () => clearTimeout(timer);
    const moved = (event: PointerEvent) => {
      if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10) cancel();
    };
    document.addEventListener("contextmenu", context);
    document.addEventListener("pointerdown", down);
    document.addEventListener("pointermove", moved);
    document.addEventListener("pointerup", cancel);
    document.addEventListener("pointercancel", cancel);
    return () => {
      cancel();
      document.removeEventListener("contextmenu", context);
      document.removeEventListener("pointerdown", down);
      document.removeEventListener("pointermove", moved);
      document.removeEventListener("pointerup", cancel);
      document.removeEventListener("pointercancel", cancel);
    };
  }, [open]);
}
